/** The four roles from CLAUDE.md §4. One role per account for v1 (ARCHITECTURE §4). */
export const ROLES = ["client", "professional", "search_agent", "admin"];
export function isRole(value) {
    return typeof value === "string" && ROLES.includes(value);
}
/**
 * Roles a person may choose for themselves when their account is first
 * provisioned. Both are unprivileged: a `client` sees only their own cases, and
 * a `professional` is not assignable to anything until an admin has verified
 * their enrolment (COMPLIANCE Constraint 5), so claiming to be one buys nothing.
 */
export const SELF_SELECTABLE_ROLES = ["client", "professional"];
export function isSelfSelectableRole(value) {
    return typeof value === "string" && SELF_SELECTABLE_ROLES.includes(value);
}
/**
 * Roles that only an existing admin may grant.
 *
 * `admin` for the obvious reason. `search_agent` because an agent is handed
 * registry extracts for real cases — the role is unregulated legwork, not a
 * public signup. Neither is ever inferred from anything the client sends.
 */
export const ADMIN_GRANTED_ROLES = ["search_agent", "admin"];
//# sourceMappingURL=roles.js.map